import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";

export const handleDownloadPDF = (bookingId, confirmationRef) => async () => {
  if (!confirmationRef.current) return;

  const element = confirmationRef.current;
  const canvas = await html2canvas(element, {
    scale: 2,
    useCORS: true,
    logging: true,
  });

  const imgData = canvas.toDataURL("image/png");
  const pdf = new jsPDF("p", "mm", "a4");
  const pdfWidth = pdf.internal.pageSize.getWidth();
  const pdfHeight = pdf.internal.pageSize.getHeight();
  const imgWidth = pdfWidth;
  const imgHeight = (canvas.height * pdfWidth) / canvas.width;

  let position = 0;
  while (position < imgHeight) {
    pdf.addImage(imgData, "PNG", 0, position * -1, imgWidth, imgHeight);
    position += pdfHeight;
    if (position < imgHeight) pdf.addPage();
  }

  pdf.save(`Booking_${bookingId}.pdf`);
};
